import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  HydrateCustomerTopPriorityRequest,
  HydrateCustomerTopPriorityResponse,
} from "@/types";

export const useHydrateCustomerTopPriority = () => {
  return useMutation({
    mutationFn: async (
      request: HydrateCustomerTopPriorityRequest,
    ): Promise<HydrateCustomerTopPriorityResponse> => {
      const res = await guacHttpClient.post<
        HydrateCustomerTopPriorityResponse,
        HttpResponse<HydrateCustomerTopPriorityResponse>,
        HydrateCustomerTopPriorityRequest
      >("search/hydrate-customer-top-priority", request);

      return res.data;
    },
  });
};
